// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./public/fonts/ppeiko/PPEiko-Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./public/fonts/ppeiko/PPEiko-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./public/fonts/ppeiko/PPEiko-LightItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./public/fonts/ppeiko/PPEiko-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./public/fonts/ppeiko/PPEiko-RegularItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./public/fonts/ppeiko/PPEiko-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./public/fonts/ppeiko/PPEiko-BoldItalic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./public/fonts/neuehaasgrotesk/NeueHaasDisplayRoman.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./public/fonts/neuehaasgrotesk/NeueHaasDisplayLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./public/fonts/neuehaasgrotesk/NeueHaasDisplayThin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./public/fonts/neuehaasgrotesk/NeueHaasDisplayMedium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.2 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
  body {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.relative {
  position: relative;
}
.col-start-1 {
  grid-column-start: 1;
}
.col-start-3 {
  grid-column-start: 3;
}
.col-end-3 {
  grid-column-end: 3;
}
.col-end-5 {
  grid-column-end: 5;
}
.block {
  display: block;
}
.hidden {
  display: none;
}
.h-screen {
  height: 100vh;
}
.w-full {
  width: 100%;
}
.flex-1 {
  flex: 1 1;
}
.resize {
  resize: both;
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.fill-black {
  fill: #000;
}
.fill-white {
  fill: #fff;
}
.pb-\\[1\\.5vw\\] {
  padding-bottom: 1.5vw;
}
.pb-\\[15vw\\] {
  padding-bottom: 15vw;
}
.pb-\\[3vw\\] {
  padding-bottom: 3vw;
}
.pt-\\[3vw\\] {
  padding-top: 3vw;
}
.uppercase {
  text-transform: uppercase;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.decoration-\\[\\#c8c5b8\\] {
  text-decoration-color: #c8c5b8;
}
.decoration-2 {
  text-decoration-thickness: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.mix-blend-difference {
  mix-blend-mode: difference;
}

::-webkit-scrollbar {
  /* display: none; */
}

* {
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
  box-sizing: border-box;

  /* IE and Edge */
  /* -ms-overflow-style: none;  */
  /* Firefox */ 
  /* scrollbar-width: none; */

  /* -webkit-tap-highlight-color: transparent; */
}

/* /////////////////////////////// FONTS /////////////////////////////////// */
/* PP EIKO */
@font-face {
  font-family: 'PPEiko';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: 'PPEiko';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'PPEiko';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: 'PPEiko';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'PPEiko';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("opentype");
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: 'PPEiko';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("opentype");
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'PPEiko';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("opentype");
  font-weight: 600;
  font-style: italic;
}

/* NEUE HAAS GROTESK */
@font-face {
  font-family: 'NeueHaasGrotesk';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'NeueHaasGroteskLight';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-weight: light;
  font-style: normal;
}

@font-face {
  font-family: 'NeueHaasGroteskThin';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-weight: thin;
  font-style: normal;
}

@font-face {
  font-family: 'NeueHaasGroteskMedium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-weight: medium;
  font-style: normal;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-column-gap: 5vw;
}
@media (min-width: 640px) {
  .grid-container{
    grid-template-columns: repeat(8, minmax(0, 1fr));
    grid-column-gap: 1.5vw;  
  }
}
@media (min-width: 1024px) {
  .grid-container{
    grid-template-columns: repeat(12, minmax(0, 1fr));
    grid-column-gap: 1.5vw;  
  }
}

.half-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-column-gap: 3vw;
}
@media (min-width: 640px) {
  .half-grid{
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-column-gap: 1.5vw;  
  }
}
@media (min-width: 1024px) {
  .half-grid{
    grid-template-columns: repeat(6, minmax(0, 1fr));
    grid-column-gap: 1.5vw;  
  }
}

.page-section {
  width: 100%;
  margin-top: 13.8vw;
}
@media (min-width: 640px){
  .page-section{
      margin-top: 7vw;
  }
}
@media (min-width: 1024px){
  .page-section{
      margin-top: 3.6vw;
  }
}

.section-bar {
  grid-column-start: 1;
  grid-column-end: 5;
  display: flex;
  justify-content: space-between;
  padding: 4vw 0 4vw 0;
  /* background-color: #fffef9; */
}
@media (min-width: 640px) {
  .section-bar{
      grid-column-start: 1;
      grid-column-end: 9;
      padding: 1.2vw 0 1.2vw 0;
  }
}
@media (min-width: 1024px) {
  .section-bar{
      grid-column-start: 1;
      grid-column-end: 13;
      padding: 0.8vw 0 0.8vw 0;
  }
}

/* .section-bar-black {
  grid-column-start: 1;
  grid-column-end: 5;
  display: flex;
  justify-content: space-between;
  padding: 4vw 0 4vw 0;
  background-color: #000000;
}
@media (min-width: 640px) {
  .section-bar-black{
      grid-column-start: 1;
      grid-column-end: 9;
      padding: 1.4vw 0 1.4vw 0;
  }
}
@media (min-width: 1024px) {
  .section-bar-black{
      grid-column-start: 1;
      grid-column-end: 13;
      padding: 0.8vw 0 0.8vw 0;
  }
} */

.sticky {
  position: sticky;
  top: 14.9vw;
  width: 100%;
  /* background-color: transparent; */
  z-index: 910;
}
@media (min-width: 640px){
  .sticky{
      top: 6.2vw;
  }
}
@media (min-width: 1024px){
  .sticky{
      top: 4.2vw;
  }
}

.sticky-second {
  position: sticky;
  top: 27.8vw;
  width: 100%;
  /* background-color: #fffef9; */
  /* padding-left: 5vw;
  padding-right: 5vw;  */
  z-index: 911;
}
@media (min-width: 640px){
  .sticky-second {
      top: 11.5vw;
      /* padding-left: 1.5vw;
      padding-right: 1.5vw; */
  }
}
@media (min-width: 1024px){
  .sticky-second {
      top: 6.8vw;
  }
}

.section-haas {
  font-family: 'NeueHaasGrotesk';
  font-weight: normal;
  font-style: normal;
  color: #000000;
  pointer-events: none;
  font-size: 4.5vw;
  line-height: 4.5vw;
  /* text-transform: uppercase; */
}
@media (min-width: 640px) {
  .section-haas{
    font-size: 1.8vw;
    line-height: 1.8vw;
  }
}
@media (min-width: 1024px) {
  .section-haas{
    font-size: 1.2vw;
    line-height: 1.2vw;
  }
}

.section-haas-black {
  font-family: 'NeueHaasGroteskLight';
  font-weight: light;
  font-style: normal;
  color: #fffef9;
  pointer-events: none;
  font-size: 5vw;
  line-height: 5vw;
}
@media (min-width: 640px) {
  .section-haas-black{
    font-size: 2.4vw;
    line-height: 2.4vw;
  }
}
@media (min-width: 1024px) {
  .section-haas-black{
    font-size: 1.3vw;
    line-height: 1.3vw;
  }
}

.section-pp {
  font-family: 'PPEiko';
  font-weight: light;
  font-style: italic;
  color: #000000;
  pointer-events: none;
  font-size: 4.5vw;
  line-height: 4.5vw;
  white-space: nowrap;
}
@media (min-width: 640px) {
  .section-pp{
    font-size: 2.4vw;
    line-height: 2.4vw;
  }
}
@media (min-width: 1024px) {
  .section-pp{
    font-size: 1.2vw;
    line-height: 1.2vw;
  }
} 

.section-pp-black {
  font-family: 'PPEiko';
  font-weight: 100;
  font-style: normal;
  color: #fffef9;
  pointer-events: none;
  font-size: 4.5vw;
  line-height: 4.5vw;
  white-space: nowrap;
}
@media (min-width: 640px) {
  .section-pp-black{
    font-size: 2.4vw;
    line-height: 2.4vw;
  }
}
@media (min-width: 1024px) {
  .section-pp-black{
    font-size: 1.3vw;
    line-height: 1.3vw;
  }
} 

.line{
  display: block;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.black-line{
  width: 100%;
  height: 0.3vw;
  background-color: #202020;
  z-index: 0;
}
@media (min-width: 640px){
  .black-line{
    height: 0.2vw;
  }
}
@media (min-width: 1024px){
  .black-line{
    height: 0.08vw;
  }
}

.white-line{
  width: 100%;
  height: 0.2vw;
  background-color: #fffef9;
  z-index: 0;
}
@media (min-width: 640px){
  .white-line{
    height: 0.04vw;
  }
}
@media (min-width: 1024px){
  .white-line{
    height: 0.04vw;
  }
}

.padding-x {
  padding-left: 5vw;
  padding-right: 5vw;
}
@media (min-width: 640px) {
  .padding-x {
    padding-left: 1.5vw;
    padding-right: 1.5vw;
  }
}

/* Client Works */
.marquee {
  position: relative;
  padding: 5vw;
  width: 100%;
  height: 54vw;
  overflow-x: hidden;
  background-color: #fffef9;
}
@media (min-width: 640px){
  .marquee{
      padding: 3vw;
      height: 35vw;
  }
}
@media (min-width: 1024px){
  .marquee{
      padding: 1.5vw;
      height: 22vw;
  }
}

.track {
  position: absolute;
  display: flex;
  white-space: nowrap;
  flex-direction: row;
  align-items: center;
  background-color: #fffef9;
}

.work-circle {
  height: 12vw;
  width: 12vw;
  border-radius: 50%;
  pointer-events: none; 
  background-color: #000000;
  flex-shrink: 0;
  margin-right: 10vw;
  margin-left: 10vw;
}
@media (min-width: 640px) {
  .work-circle{
      height: 7vw;
      width: 7vw;
      margin-right: 5vw;
      margin-left: 5vw;
  }
}
@media (min-width: 1024px) {
  .work-circle{
      height: 4.5vw;
      width: 4.5vw;
      margin-right: 5vw;
      margin-left: 5vw;
  }
}

.client-title {
  font-family: 'PPEiko';
  font-weight: 100;
  font-style: normal;
  color: #000000;
  font-size: 40vw;
  line-height: 40vw;
  pointer-events: none;
}
@media (min-width: 640px) {
  .client-title{
      font-size: 26vw;
      line-height: 26vw;
  }
}
@media (min-width: 1024px) {
  .client-title{
      font-size: 18vw;
      line-height: 18vw;
  }
}

.main-img {
  width: auto;
  height: 120vw;
  object-fit: cover;
  object-position: -70vw;
}
@media (min-width: 640px) {
  .main-img{
      width: 100%;
      height: auto;  
      object-position: center;  
  }
}
@media (min-width: 1024px) {
  .main-img{
      width: auto;
      height: 40vw;  
      object-position: center;  
  }
}

.client-bar {
  padding: 4vw 0 4vw 0;
  background-color: #fffef9;
}
@media (min-width: 640px) {
  .client-bar{
      padding: 1.4vw 0 1.4vw 0;
  }
}
@media (min-width: 1024px) {
  .client-bar{
      padding: 0.8vw 0 0.8vw 0;
  }
}

.client-detail-bar {
  padding: 4vw 0 4vw 0;
}
@media (min-width: 640px){
  .client-detail-bar{
      padding: 1.4vw 0 1.4vw 0;
  }
}
@media (min-width: 1024px){
  .client-detail-bar{
      padding: 0.8vw 0 0.8vw 0;  
  }
}

.client-detail-haas {
  font-family: 'NeueHaasGroteskLight';
  font-weight: light;
  font-style: normal;
  color: #000000;
  pointer-events: none;
  font-size: 4.5vw;
  line-height: 6vw;

}
@media (min-width: 640px){
  .client-detail-haas{
      font-size: 2.8vw;
      line-height: 3.4vw;
  }
}
@media (min-width: 1024px){
  .client-detail-haas{
      font-size: 1.3vw;
      line-height: 1.6vw;
  }
}

.main-text-container {
  width: 100%;
  padding: 8vw 5vw 8vw 5vw;
}
@media (min-width: 640px) {
  .main-text-container {
      padding: 4vw 1.5vw 4vw 1.5vw;
  }
}

.main-text-haas {
  font-family: 'NeueHaasGroteskLight';
  font-weight: light;
  font-style: normal;
  pointer-events: none;
  color: #000000;
  font-size: 10.5vw;
  line-height: 10.5vw;
  white-space: nowrap;
  height: 10.5vw;
  /* background-color: blue; */
}
@media (min-width: 640px) {
  .main-text-haas {
      font-size: 6vw;
      line-height: 6vw;
      height: 6vw;
  }
}

.main-text-pp {
  font-family: 'PPEiko';
  font-weight: thin;
  font-style: italic;
  pointer-events: none;
  color: #000000;
  font-size: 10.5vw;
  line-height: 9vw;
  white-space: nowrap;
  height: 10.5vw;
  /* background-color: red; */
}
@media (min-width: 640px) {
  .main-text-pp {
      font-size: 5.8vw;
      line-height: 5.4vw;
      height: 6vw;
  }
}
@media (min-width: 1024px) {
  .main-text-pp {
      font-size: 6.2vw;
      line-height: 5.3vw;
      height: 6vw;
  }
}

.anchor-haas {
  font-family: 'NeueHaasGroteskLight';
  font-weight: light;
  font-style: normal;
  color: #000000;
  cursor: pointer;
  font-size: 4.5vw;
  line-height: 4.5vw;
}
@media (min-width: 640px) {
  .anchor-haas{
      font-size: 2.4vw;
      line-height: 2.4vw;
  }
}
@media (min-width: 1024px) {
  .anchor-haas{
      font-size: 1.3vw;
      line-height: 1.3vw;
  }
}

/*  */

@media (min-width: 640px) {

  .sm\\:col-start-5 {
    grid-column-start: 5;
  }

  .sm\\:col-start-7 {
    grid-column-start: 7;
  }

  .sm\\:col-end-4 {
    grid-column-end: 4;
  }

  .sm\\:col-end-7 {
    grid-column-end: 7;
  }

  .sm\\:col-end-9 {
    grid-column-end: 9;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:pb-\\[1\\.5vw\\] {
    padding-bottom: 1.5vw;
  }

  .sm\\:pb-\\[5vw\\] {
    padding-bottom: 5vw;
  }

  .sm\\:pt-0 {
    padding-top: 0px;
  }

  .sm\\:pt-\\[1\\.5vw\\] {
    padding-top: 1.5vw;
  }

  .sm\\:pt-\\[4\\.5vw\\] {
    padding-top: 4.5vw;
  }
}

@media (min-width: 1024px) {

  .lg\\:col-start-10 {
    grid-column-start: 10;
  }

  .lg\\:col-start-6 {
    grid-column-start: 6;
  }

  .lg\\:col-start-8 {
    grid-column-start: 8;
  }

  .lg\\:col-end-10 {
    grid-column-end: 10;
  }

  .lg\\:col-end-12 {
    grid-column-end: 12;
  }

  .lg\\:col-end-5 {
    grid-column-end: 5;
  }

  .lg\\:col-end-8 {
    grid-column-end: 8;
  }

  .lg\\:pb-\\[1vw\\] {
    padding-bottom: 1vw;
  }

  .lg\\:pb-\\[3vw\\] {
    padding-bottom: 3vw;
  }

  .lg\\:pt-0 {
    padding-top: 0px;
  }

  .lg\\:pt-\\[1vw\\] {
    padding-top: 1vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css","<no source>"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;EAAA,kBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAQnB;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,sBAAsB;;EAEtB,gBAAgB;EAChB,+BAA+B;EAC/B,YAAY;EACZ,2BAA2B;;EAE3B,8CAA8C;AAChD;;AAEA,8EAA8E;AAC9E,YAAY;AACZ;EACE,qBAAqB;EACrB,+DAAoE;EACpE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAsE;EACtE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAA2E;EAC3E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAuE;EACvE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAA6E;EAC7E,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAAoE;EACpE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+DAA0E;EAC1E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,8BAA8B;EAC9B,4CAAmE;EACnE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,4CAAmE;EACnE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,4CAAkE;EAClE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,6CAAoE;EACpE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;AACtB;AACA;EACE;IACE,gDAAgD;IAChD,sBAAsB;EACxB;AACF;AACA;EACE;IACE,iDAAiD;IACjD,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;AACtB;AACA;EACE;IACE,gDAAgD;IAChD,sBAAsB;EACxB;AACF;AACA;EACE;IACE,gDAAgD;IAChD,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;MACI,eAAe;EACnB;AACF;AACA;EACE;MACI,iBAAiB;EACrB;AACF;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE;MACI,oBAAoB;MACpB,kBAAkB;MAClB,wBAAwB;EAC5B;AACF;AACA;EACE;MACI,oBAAoB;MACpB,mBAAmB;MACnB,wBAAwB;EAC5B;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,YAAY;AACd;AACA;EACE;MACI,UAAU;EACd;AACF;AACA;EACE;MACI,UAAU;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B;wBACsB;EACtB,YAAY;AACd;AACA;EACE;MACI,WAAW;MACX;6BACuB;EAC3B;AACF;AACA;EACE;MACI,UAAU;EACd;AACF;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE;MACI,YAAY;MACZ,YAAY;EAChB;AACF;AACA;EACE;MACI,cAAc;MACd,YAAY;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;MACI,WAAW;MACX,UAAU;MACV,iBAAiB;MACjB,gBAAgB;EACpB;AACF;AACA;EACE;MACI,aAAa;MACb,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE;MACI,eAAe;MACf,iBAAiB;EACrB;AACF;AACA;EACE;MACI,eAAe;MACf,iBAAiB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE;MACI,WAAW;MACX,YAAY;MACZ,uBAAuB;EAC3B;AACF;AACA;EACE;MACI,WAAW;MACX,YAAY;MACZ,uBAAuB;EAC3B;AACF;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE;MACI,wBAAwB;EAC5B;AACF;AACA;EACE;MACI,wBAAwB;EAC5B;AACF;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE;MACI,wBAAwB;EAC5B;AACF;AACA;EACE;MACI,wBAAwB;EAC5B;AACF;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;;AAElB;AACA;EACE;MACI,gBAAgB;MAChB,kBAAkB;EACtB;AACF;AACA;EACE;MACI,gBAAgB;MAChB,kBAAkB;EACtB;AACF;;AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE;MACI,4BAA4B;EAChC;AACF;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE;MACI,cAAc;MACd,gBAAgB;MAChB,WAAW;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE;MACI,gBAAgB;MAChB,kBAAkB;MAClB,WAAW;EACf;AACF;AACA;EACE;MACI,gBAAgB;MAChB,kBAAkB;MAClB,WAAW;EACf;AACF;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;MACI,gBAAgB;MAChB,kBAAkB;EACtB;AACF;AACA;EACE;MACI,gBAAgB;MAChB,kBAAkB;EACtB;AACF;;AAEA,KAAK;;AA5mBL;;EAAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;CAAA;;ADAA;;EAAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;;EDAA;IAAA;GCAA;CAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  body {\n    @apply bg-[#ffffff];\n  }\n}\n\n::-webkit-scrollbar {\n  /* display: none; */\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  scroll-behavior: smooth;\n  box-sizing: border-box;\n\n  /* IE and Edge */\n  /* -ms-overflow-style: none;  */\n  /* Firefox */ \n  /* scrollbar-width: none; */\n\n  /* -webkit-tap-highlight-color: transparent; */\n}\n\n/* /////////////////////////////// FONTS /////////////////////////////////// */\n/* PP EIKO */\n@font-face {\n  font-family: 'PPEiko';\n  src: url('./public/fonts/ppeiko/PPEiko-Thin.otf') format(\"opentype\");\n  font-weight: 100;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'PPEiko';\n  src: url('./public/fonts/ppeiko/PPEiko-Medium.otf') format(\"opentype\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'PPEiko';\n  src: url('./public/fonts/ppeiko/PPEiko-LightItalic.otf') format(\"opentype\");\n  font-weight: 300;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'PPEiko';\n  src: url('./public/fonts/ppeiko/PPEiko-Regular.otf') format(\"opentype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'PPEiko';\n  src: url('./public/fonts/ppeiko/PPEiko-RegularItalic.otf') format(\"opentype\");\n  font-weight: normal;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'PPEiko';\n  src: url('./public/fonts/ppeiko/PPEiko-Bold.otf') format(\"opentype\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'PPEiko';\n  src: url('./public/fonts/ppeiko/PPEiko-BoldItalic.otf') format(\"opentype\");\n  font-weight: 600;\n  font-style: italic;\n}\n\n/* NEUE HAAS GROTESK */\n@font-face {\n  font-family: 'NeueHaasGrotesk';\n  src: url('./public/fonts/neuehaasgrotesk/NeueHaasDisplayRoman.ttf');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'NeueHaasGroteskLight';\n  src: url('./public/fonts/neuehaasgrotesk/NeueHaasDisplayLight.ttf');\n  font-weight: light;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'NeueHaasGroteskThin';\n  src: url('./public/fonts/neuehaasgrotesk/NeueHaasDisplayThin.ttf');\n  font-weight: thin;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'NeueHaasGroteskMedium';\n  src: url('./public/fonts/neuehaasgrotesk/NeueHaasDisplayMedium.ttf');\n  font-weight: medium;\n  font-style: normal;\n}\n\n.grid-container {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  grid-column-gap: 5vw;\n}\n@media (min-width: 640px) {\n  .grid-container{\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n    grid-column-gap: 1.5vw;  \n  }\n}\n@media (min-width: 1024px) {\n  .grid-container{\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n    grid-column-gap: 1.5vw;  \n  }\n}\n\n.half-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  grid-column-gap: 3vw;\n}\n@media (min-width: 640px) {\n  .half-grid{\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    grid-column-gap: 1.5vw;  \n  }\n}\n@media (min-width: 1024px) {\n  .half-grid{\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n    grid-column-gap: 1.5vw;  \n  }\n}\n\n.page-section {\n  width: 100%;\n  margin-top: 13.8vw;\n}\n@media (min-width: 640px){\n  .page-section{\n      margin-top: 7vw;\n  }\n}\n@media (min-width: 1024px){\n  .page-section{\n      margin-top: 3.6vw;\n  }\n}\n\n.section-bar {\n  grid-column-start: 1;\n  grid-column-end: 5;\n  display: flex;\n  justify-content: space-between;\n  padding: 4vw 0 4vw 0;\n  /* background-color: #fffef9; */\n}\n@media (min-width: 640px) {\n  .section-bar{\n      grid-column-start: 1;\n      grid-column-end: 9;\n      padding: 1.2vw 0 1.2vw 0;\n  }\n}\n@media (min-width: 1024px) {\n  .section-bar{\n      grid-column-start: 1;\n      grid-column-end: 13;\n      padding: 0.8vw 0 0.8vw 0;\n  }\n}\n\n/* .section-bar-black {\n  grid-column-start: 1;\n  grid-column-end: 5;\n  display: flex;\n  justify-content: space-between;\n  padding: 4vw 0 4vw 0;\n  background-color: #000000;\n}\n@media (min-width: 640px) {\n  .section-bar-black{\n      grid-column-start: 1;\n      grid-column-end: 9;\n      padding: 1.4vw 0 1.4vw 0;\n  }\n}\n@media (min-width: 1024px) {\n  .section-bar-black{\n      grid-column-start: 1;\n      grid-column-end: 13;\n      padding: 0.8vw 0 0.8vw 0;\n  }\n} */\n\n.sticky {\n  position: sticky;\n  top: 14.9vw;\n  width: 100%;\n  /* background-color: transparent; */\n  z-index: 910;\n}\n@media (min-width: 640px){\n  .sticky{\n      top: 6.2vw;\n  }\n}\n@media (min-width: 1024px){\n  .sticky{\n      top: 4.2vw;\n  }\n}\n\n.sticky-second {\n  position: sticky;\n  top: 27.8vw;\n  width: 100%;\n  /* background-color: #fffef9; */\n  /* padding-left: 5vw;\n  padding-right: 5vw;  */\n  z-index: 911;\n}\n@media (min-width: 640px){\n  .sticky-second {\n      top: 11.5vw;\n      /* padding-left: 1.5vw;\n      padding-right: 1.5vw; */\n  }\n}\n@media (min-width: 1024px){\n  .sticky-second {\n      top: 6.8vw;\n  }\n}\n\n.section-haas {\n  font-family: 'NeueHaasGrotesk';\n  font-weight: normal;\n  font-style: normal;\n  color: #000000;\n  pointer-events: none;\n  font-size: 4.5vw;\n  line-height: 4.5vw;\n  /* text-transform: uppercase; */\n}\n@media (min-width: 640px) {\n  .section-haas{\n    font-size: 1.8vw;\n    line-height: 1.8vw;\n  }\n}\n@media (min-width: 1024px) {\n  .section-haas{\n    font-size: 1.2vw;\n    line-height: 1.2vw;\n  }\n}\n\n.section-haas-black {\n  font-family: 'NeueHaasGroteskLight';\n  font-weight: light;\n  font-style: normal;\n  color: #fffef9;\n  pointer-events: none;\n  font-size: 5vw;\n  line-height: 5vw;\n}\n@media (min-width: 640px) {\n  .section-haas-black{\n    font-size: 2.4vw;\n    line-height: 2.4vw;\n  }\n}\n@media (min-width: 1024px) {\n  .section-haas-black{\n    font-size: 1.3vw;\n    line-height: 1.3vw;\n  }\n}\n\n.section-pp {\n  font-family: 'PPEiko';\n  font-weight: light;\n  font-style: italic;\n  color: #000000;\n  pointer-events: none;\n  font-size: 4.5vw;\n  line-height: 4.5vw;\n  white-space: nowrap;\n}\n@media (min-width: 640px) {\n  .section-pp{\n    font-size: 2.4vw;\n    line-height: 2.4vw;\n  }\n}\n@media (min-width: 1024px) {\n  .section-pp{\n    font-size: 1.2vw;\n    line-height: 1.2vw;\n  }\n} \n\n.section-pp-black {\n  font-family: 'PPEiko';\n  font-weight: 100;\n  font-style: normal;\n  color: #fffef9;\n  pointer-events: none;\n  font-size: 4.5vw;\n  line-height: 4.5vw;\n  white-space: nowrap;\n}\n@media (min-width: 640px) {\n  .section-pp-black{\n    font-size: 2.4vw;\n    line-height: 2.4vw;\n  }\n}\n@media (min-width: 1024px) {\n  .section-pp-black{\n    font-size: 1.3vw;\n    line-height: 1.3vw;\n  }\n} \n\n.line{\n  display: block;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.black-line{\n  width: 100%;\n  height: 0.3vw;\n  background-color: #202020;\n  z-index: 0;\n}\n@media (min-width: 640px){\n  .black-line{\n    height: 0.2vw;\n  }\n}\n@media (min-width: 1024px){\n  .black-line{\n    height: 0.08vw;\n  }\n}\n\n.white-line{\n  width: 100%;\n  height: 0.2vw;\n  background-color: #fffef9;\n  z-index: 0;\n}\n@media (min-width: 640px){\n  .white-line{\n    height: 0.04vw;\n  }\n}\n@media (min-width: 1024px){\n  .white-line{\n    height: 0.04vw;\n  }\n}\n\n.padding-x {\n  padding-left: 5vw;\n  padding-right: 5vw;\n}\n@media (min-width: 640px) {\n  .padding-x {\n    padding-left: 1.5vw;\n    padding-right: 1.5vw;\n  }\n}\n\n/* Client Works */\n.marquee {\n  position: relative;\n  padding: 5vw;\n  width: 100%;\n  height: 54vw;\n  overflow-x: hidden;\n  background-color: #fffef9;\n}\n@media (min-width: 640px){\n  .marquee{\n      padding: 3vw;\n      height: 35vw;\n  }\n}\n@media (min-width: 1024px){\n  .marquee{\n      padding: 1.5vw;\n      height: 22vw;\n  }\n}\n\n.track {\n  position: absolute;\n  display: flex;\n  white-space: nowrap;\n  flex-direction: row;\n  align-items: center;\n  background-color: #fffef9;\n}\n\n.work-circle {\n  height: 12vw;\n  width: 12vw;\n  border-radius: 50%;\n  pointer-events: none; \n  background-color: #000000;\n  flex-shrink: 0;\n  margin-right: 10vw;\n  margin-left: 10vw;\n}\n@media (min-width: 640px) {\n  .work-circle{\n      height: 7vw;\n      width: 7vw;\n      margin-right: 5vw;\n      margin-left: 5vw;\n  }\n}\n@media (min-width: 1024px) {\n  .work-circle{\n      height: 4.5vw;\n      width: 4.5vw;\n      margin-right: 5vw;\n      margin-left: 5vw;\n  }\n}\n\n.client-title {\n  font-family: 'PPEiko';\n  font-weight: 100;\n  font-style: normal;\n  color: #000000;\n  font-size: 40vw;\n  line-height: 40vw;\n  pointer-events: none;\n}\n@media (min-width: 640px) {\n  .client-title{\n      font-size: 26vw;\n      line-height: 26vw;\n  }\n}\n@media (min-width: 1024px) {\n  .client-title{\n      font-size: 18vw;\n      line-height: 18vw;\n  }\n}\n\n.main-img {\n  width: auto;\n  height: 120vw;\n  object-fit: cover;\n  object-position: -70vw;\n}\n@media (min-width: 640px) {\n  .main-img{\n      width: 100%;\n      height: auto;  \n      object-position: center;  \n  }\n}\n@media (min-width: 1024px) {\n  .main-img{\n      width: auto;\n      height: 40vw;  \n      object-position: center;  \n  }\n}\n\n.client-bar {\n  padding: 4vw 0 4vw 0;\n  background-color: #fffef9;\n}\n@media (min-width: 640px) {\n  .client-bar{\n      padding: 1.4vw 0 1.4vw 0;\n  }\n}\n@media (min-width: 1024px) {\n  .client-bar{\n      padding: 0.8vw 0 0.8vw 0;\n  }\n}\n\n.client-detail-bar {\n  padding: 4vw 0 4vw 0;\n}\n@media (min-width: 640px){\n  .client-detail-bar{\n      padding: 1.4vw 0 1.4vw 0;\n  }\n}\n@media (min-width: 1024px){\n  .client-detail-bar{\n      padding: 0.8vw 0 0.8vw 0;  \n  }\n}\n\n.client-detail-haas {\n  font-family: 'NeueHaasGroteskLight';\n  font-weight: light;\n  font-style: normal;\n  color: #000000;\n  pointer-events: none;\n  font-size: 4.5vw;\n  line-height: 6vw;\n\n}\n@media (min-width: 640px){\n  .client-detail-haas{\n      font-size: 2.8vw;\n      line-height: 3.4vw;\n  }\n}\n@media (min-width: 1024px){\n  .client-detail-haas{\n      font-size: 1.3vw;\n      line-height: 1.6vw;\n  }\n}\n\n.main-text-container {\n  width: 100%;\n  padding: 8vw 5vw 8vw 5vw;\n}\n@media (min-width: 640px) {\n  .main-text-container {\n      padding: 4vw 1.5vw 4vw 1.5vw;\n  }\n}\n\n.main-text-haas {\n  font-family: 'NeueHaasGroteskLight';\n  font-weight: light;\n  font-style: normal;\n  pointer-events: none;\n  color: #000000;\n  font-size: 10.5vw;\n  line-height: 10.5vw;\n  white-space: nowrap;\n  height: 10.5vw;\n  /* background-color: blue; */\n}\n@media (min-width: 640px) {\n  .main-text-haas {\n      font-size: 6vw;\n      line-height: 6vw;\n      height: 6vw;\n  }\n}\n\n.main-text-pp {\n  font-family: 'PPEiko';\n  font-weight: thin;\n  font-style: italic;\n  pointer-events: none;\n  color: #000000;\n  font-size: 10.5vw;\n  line-height: 9vw;\n  white-space: nowrap;\n  height: 10.5vw;\n  /* background-color: red; */\n}\n@media (min-width: 640px) {\n  .main-text-pp {\n      font-size: 5.8vw;\n      line-height: 5.4vw;\n      height: 6vw;\n  }\n}\n@media (min-width: 1024px) {\n  .main-text-pp {\n      font-size: 6.2vw;\n      line-height: 5.3vw;\n      height: 6vw;\n  }\n}\n\n.anchor-haas {\n  font-family: 'NeueHaasGroteskLight';\n  font-weight: light;\n  font-style: normal;\n  color: #000000;\n  cursor: pointer;\n  font-size: 4.5vw;\n  line-height: 4.5vw;\n}\n@media (min-width: 640px) {\n  .anchor-haas{\n      font-size: 2.4vw;\n      line-height: 2.4vw;\n  }\n}\n@media (min-width: 1024px) {\n  .anchor-haas{\n      font-size: 1.3vw;\n      line-height: 1.3vw;\n  }\n}\n\n/*  */",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
